export default __webpack_public_path__ + "static/media/banner-consumption-mobile-comp.be0a2fff.jpg";